module.exports = __webpack_public_path__ + "img/HA2512-83.c06e4eb2.jpg";